import BasePage from "./BasePage";
import LegacyFormHelper from "@Scripts/Infrastructure/LegacyFormHelper";

export default class EventSelectionPage extends BasePage {
    
    public static async init() {
        await super.init();
        
        this.setForm();
    }

    private static setForm() {
        var $form = $("#FormEventSelection"),         
            $disableOnSubmit = $(".disable-on-submit", $form);

        (<any>$form).ajaxForm({
            iframe: false,
            dataType: "json",
            beforeSubmit: function (formData, jqForm, options) {
                $disableOnSubmit.attr("disabled", "disabled");
                LegacyFormHelper.resetValidation($form);
            },
            success: function (data) {
                LegacyFormHelper.resetValidation($form);

                if (data.eventIdMaster) {
                    window.location.href = (<any>window).App.routes.TestRideEvent_App_Intro + "?eventIdMaster=" + data.eventIdMaster;
                } else {
                    $disableOnSubmit.removeAttr("disabled");
                    LegacyFormHelper.setValidation($form, data.state);
                }
            },
            error: function (xhr, textStatus, errorThrown) {
                LegacyFormHelper.enableControls($form);
                LegacyFormHelper.setValidation($form, xhr.responseJSON);
            }
        });
    }
}